<main>
  <form [formGroup]="credentialForm">
    <div class="container my-5 pt-5 pt-md-0">
      <div class="shadow rounded-4 p-4 p-md-5 bg-white m-auto register-container">
        <div class="m-auto">
          <h1 class="page-title">Registreren organisatie</h1>
        </div>
        <div class="row mb-4">
          <div class="m-auto">
            <a [routerLink]="['/account/registreren/']" class="organiser-link mb-5"><i class="bi bi-chevron-right"></i>Ik ben een bezoeker</a>
          </div>
        </div>
        <div class="row mb-4">
          <div class="m-auto">
            <label for="organization-input" class="form-label">Naam organisatie</label>
            <input type="text" class="form-control" formControlName="organization" id="organization-input">
          </div>
        </div>
        <div class="row mb-4">
          <div class="m-auto">
            <label for="address-input" class="form-label">Adres</label>
            <input type="text" class="form-control" formControlName="address" id="address-input">
          </div>
        </div>
        <div class="row mb-4">
          <div class="m-auto">
            <label for="contact-name-input" class="form-label">Naam contactpersoon</label>
            <input type="text" class="form-control" formControlName="contactName" id="contact-name-input">
          </div>
        </div>
        <div class="row mb-4">
          <div class="m-auto">
            <label for="contact-phone-input" class="form-label">Telefoonnummer</label>
            <input type="number" class="form-control" formControlName="contactPhone" id="contact-phone-input">
          </div>
        </div>
        <div class="row mb-4">
          <div class="m-auto">
            <label for="email-input" class="form-label">Email</label>
            <input type="email" class="form-control" formControlName="email" id="email-input">
          </div>
        </div>
        <div class="row mb-5">
          <div class="m-auto">
            <label for="password-input" class="form-label">Wachtwoord</label>
            <input type="password" class="form-control" formControlName="password" id="password-input">
          </div>
        </div>
        <div class="row m-auto">
          <button type="submit" class="btn btn-primary mb-2 btn-register m-auto" (click)="signUp()">Registreren</button>
          <p class="form-text text-center">Heb je al een account? <span [routerLink]="['/account/inloggen']" class="url">Log in</span></p>
        </div>
      </div>
    </div>
  </form>
</main>
